import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MenuDto } from "src/dtos/menu/menuDto";
import usePDAResetStore from "src/store/pda/usePDAResetStore";
import usePDAMenuStore from "src/store/pda/usePDAMenuStore";

/**
 * PDA 화면 공통 로직 훅
 * - Reset 함수 자동 등록
 * - 메뉴 클릭 핸들러 제공
 */
export const usePDAContainer = (reset: () => void) => {
  const { registerReset } = usePDAResetStore();
  const { setSelectedMenu } = usePDAMenuStore();
  const navigate = useNavigate();

  // Reset 함수 자동 등록
  useEffect(() => {
    const cleanup = registerReset(reset);
    return cleanup;
  }, [registerReset, reset]);

  // 사이드바에서 메뉴 클릭 시 처리
  const handleMenuClick = (menu: MenuDto) => {
    setSelectedMenu(menu);
    navigate('/');
  };

  return {
    handleMenuClick,
  };
};





